import { useState, useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import Icon from '@components/shared/Icon'
import useT from '@hooks/useTranslation'

import styles from 'styles/add/Equipment.module.css'

const Equipment = ({ name = 'wyposazenie', defaultValue, safety, comfort, limit = 18 }) => {
    const [state, setState] = useState({})
    const [isOpen, setIsOpen] = useState(false)
    const { register, unregister, setValue } = useFormContext()

    useEffect(() => {
        if (defaultValue) setState(arrayToBoolObject(defaultValue))
    }, [defaultValue])

    useEffect(() => {
        register(name)
        return () => unregister(name)
    }, [])

    const setOption = (option) => {
        const newState = {...state}

        if (newState[option]) delete newState[option]
        else newState[option] = true

        setValue(name, boolObjectToArray(newState))
        setState(newState)
    }

    const onClick = (e) => {
        e.preventDefault()
        const { currentTarget } = e
        const value = currentTarget.getAttribute('value')
        if (value) setOption(value)
    }

    const toggleOpen = (e) => {
        e.preventDefault()
        setIsOpen(!isOpen)
    }

    const applyLimit = isOpen
        ? -1
        : limit

    const displayButton = safety.length > limit
        || comfort.length > limit

    return (
        <div>
            <h3 className={styles.h}>{useT('Bezpieczeństwo')}</h3>
            <Buttons store={state} items={safety} onClick={onClick} limit={applyLimit} />
            <br/>

            <h3 className={styles.h}>{useT('Komfort')}</h3>
            <Buttons store={state} items={comfort} onClick={onClick} limit={applyLimit} />
            <br />

            { displayButton && <button className={styles.open} onClick={toggleOpen}><Icon>{isOpen
                ? 'expand_less'
                : 'more_horiz'}</Icon></button> }
        </div>
    )
}

function Buttons ({ store, items, onClick, limit }) {
    const activeItems = (limit > 0) && (limit < items.length)
        ? items.slice(0, limit)
        : items

    return (
        <Wrapper>
            { activeItems.map(item => {
                const isActive = store[item] === true
                const name = useT(item)
                return <button
                    key={item}
                    value={item}
                    onClick={onClick}
                    className="bt"
                    active={isActive
                        ? "true"
                        : undefined}>{name}</button>
            })}
        </Wrapper>
    )
}

function Wrapper ({ children }) {
    return (
        <div className={styles.wrapper}>
            { children }
        </div>
    )
}

function arrayToBoolObject (array) {
    const object = {}
    if (!Array.isArray(array)) return object
    for (const item of array) {
        object[item] = true
    }
    return object
}

function boolObjectToArray (object) {
    const array = []
    if (typeof object !== 'object') return array
    for (const key in object) {
        if (object[key] === true) array.push(key)
    }
    return array
}

export default Equipment